import { useState, useEffect } from "react";
import BarraSuperior from "../barra_superior";
import AnimacionCarga from "../animacion_de_carga";
import BotonFlotante from "../BotonFlotante";
import { consultarSimple, crearRegistro, actualizarRegistro } from "../../../functions/crud";
import { CONFIG } from "../../../functions/variables_globales";

const ESTADOS = {
  pendiente: { color: "#FF9800", label: "Pendiente" },
  en_proceso: { color: "#2196F3", label: "En Proceso" },
  finalizado: { color: "#4CAF50", label: "Finalizado" },
  cancelado: { color: "#9E9E9E", label: "Cancelado" }
};

const COLS = [
  { k: "fecha_inicio", l: "FECHA INICIO" }, { k: "fecha_fin", l: "FECHA FIN" },
  { k: "modulo", l: "TAREA" }, { k: "tipo", l: "TIPO" },
  { k: "quien_delega", l: "QUIEN DELEGA" }, { k: "responsable", l: "RESPONSABLE" },
  { k: "tiempo_real", l: "TIEMPO REQUERIDO" }, { k: "estado", l: "ESTADO" },
  { k: "cliente", l: "CLIENTE" }, { k: "comentarios", l: "COMENTARIOS" }
];

const obtenerFechaHoy = () => new Date().toISOString().split("T")[0];

const INICIAL = {
  fecha_inicio: obtenerFechaHoy(),
  fecha_fin: obtenerFechaHoy(),
  modulo: "Soporte", 
  tipo: "General", 
  quien_delega: "Propia", 
  responsable: localStorage.getItem("NombreCompleto") || "",
  tiempo_real: 0.5,
  estado: "Pendiente", 
  cliente: "Coordinar",
  comentarios: ""
};

const FormularioModal = ({ isOpen, modo, dataInicial, catalogos, onClose, onSave }) => {
  const [formData, setFormData] = useState(dataInicial || INICIAL);
  const [guardando, setGuardando] = useState(false);

  useEffect(() => {
    if (modo === "crear") {
      setFormData({
        ...INICIAL,
        fecha_inicio: obtenerFechaHoy(),
        fecha_fin: obtenerFechaHoy()
      });
    } else {
      setFormData(dataInicial || INICIAL);
    }
  }, [dataInicial, isOpen, modo]);

  const handleChange = (campo, valor) => {
    setFormData(prev => {
      const newData = { ...prev, [campo]: valor };
      
      if (campo === "quien_delega" && valor === "Propia") {
        const nombreCompleto = localStorage.getItem("NombreCompleto");
        if (nombreCompleto) {
          newData.responsable = nombreCompleto;
        }
      }
      
      if (campo === "quien_delega" && valor === "Jorge Andrés Granada Castro") {
        newData.responsable = "Andres Mauricio Robayo Vargas";
      }

      if (campo === "quien_delega" && valor === "Andres Mauricio Robayo Vargas") {
        newData.responsable = "Jorge Andrés Granada Castro";
      }
      
      return newData;
    });
  };

  const handleSubmit = async () => {
    if (!formData.fecha_inicio || !formData.modulo || !formData.responsable) {
      alert("Complete los campos obligatorios");
      return;
    }

    setGuardando(true);
    try {
      await onSave(formData);
    } catch (e) {
      console.error(e);
    } finally {
      setGuardando(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div style={S.overlay} onClick={onClose}>
      <div style={S.modal} onClick={e => e.stopPropagation()}>
        <div style={S.header}>
          <h2 style={S.titulo}>{modo === "editar" ? "✏️ Editar" : "➕ Nueva"} Actividad</h2>
          <button style={S.cerrar} onClick={onClose}>✕</button>
        </div>

        <div style={S.contenido}>
          <div style={S.grid}>
            <Campo 
              label="📅 Fecha Inicio" 
              type="date" 
              value={formData.fecha_inicio}
              onChange={v => handleChange("fecha_inicio", v)}
              required
            />
            <Campo 
              label="📅 Fecha Fin" 
              type="date" 
              value={formData.fecha_fin}
              onChange={v => handleChange("fecha_fin", v)}
            />
            <Campo 
              label="📋 Módulo / Tarea" 
              type="select" 
              value={formData.modulo}
              onChange={v => handleChange("modulo", v)}
              options={catalogos.modulos}
              required
            />
            <Campo 
              label="🏷️ Tipo" 
              type="select" 
              value={formData.tipo}
              onChange={v => handleChange("tipo", v)}
              options={catalogos.tipos}
            />
            <Campo 
              label="👤 Quien Delega" 
              type="select" 
              value={formData.quien_delega}
              onChange={v => handleChange("quien_delega", v)}
              options={catalogos.funcionarios}
              filtro={f => f.activo && f.puede_delegar}
            />
            <Campo 
              label="👨‍💼 Responsable" 
              type="select" 
              value={formData.responsable}
              onChange={v => handleChange("responsable", v)}
              options={catalogos.funcionarios}
              filtro={f => f.activo && f.puede_ejecutar}
              required
            />
            <Campo 
              label="🏢 Cliente" 
              value={formData.cliente}
              onChange={v => handleChange("cliente", v)}
              placeholder="Nombre del cliente"
            />
            <Campo 
              label="⏱️ Tiempo Real (horas)" 
              type="number" 
              step="0.1"
              value={formData.tiempo_real}
              onChange={v => handleChange("tiempo_real", v)}
            />
            <Campo 
              label="🔄 Estado" 
              type="select" 
              value={formData.estado}
              onChange={v => handleChange("estado", v)}
              options={Object.entries(ESTADOS).reduce((acc, [k, v]) => 
                ({...acc, [k]: {nombre: v.label, valor: v.label, activo: true}}), {})}
            />
            
            <div style={{ gridColumn: "1 / -1" }}>
              <Campo 
                label="💬 Comentarios" 
                type="textarea" 
                value={formData.comentarios}
                onChange={v => handleChange("comentarios", v)}
                placeholder="Describe los detalles..."
                largo
              />
            </div>
          </div>

          <div style={S.botones}>
            <button 
              onClick={handleSubmit} 
              disabled={guardando}
              style={{...S.boton, ...S.btnPri, opacity: guardando ? 0.6 : 1}}
            >
              {guardando ? "⏳ Guardando..." : modo === "editar" ? "✅ Actualizar" : "✅ Crear"}
            </button>
            <button onClick={onClose} style={{...S.boton, ...S.btnSec}}>
              ❌ Cancelar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

const Campo = ({ label, type = "text", value, onChange, required, options, filtro, largo, ...props }) => (
  <div style={S.campo}>
    <label style={S.label}>
      {label} {required && <span style={S.req}>*</span>}
    </label>
    {type === "select" ? (
      <select 
        value={value} 
        onChange={e => onChange(e.target.value)} 
        style={S.input}
        required={required}
      >
        <option value="">Seleccionar...</option>
        {Object.entries(options || {})
          .filter(([_, i]) => filtro ? filtro(i) : i.activo)
          .map(([id, i]) => (
            <option key={id} value={i.nombre || i.valor}>
              {i.nombre || i.label}
            </option>
          ))}
      </select>
    ) : type === "textarea" ? (
      <textarea 
        value={value} 
        onChange={e => onChange(e.target.value)} 
        style={largo ? S.textareaL : S.textarea}
        {...props}
      />
    ) : (
      <input 
        type={type} 
        value={value} 
        onChange={e => onChange(e.target.value)} 
        style={S.input}
        required={required}
        {...props}
      />
    )}
  </div>
);

const Badge = ({ val, cfg }) => (
  <span style={{ 
    backgroundColor: cfg.color, 
    color: "#fff", 
    padding: "6px 14px",
    borderRadius: "14px", 
    fontWeight: "500", 
    fontSize: "0.85em", 
    display: "inline-block", 
    whiteSpace: "nowrap" 
  }}>
    {cfg.nombre || cfg.label}
  </span>
);

const ActividadesUnificado = () => {
  const [datos, setDatos] = useState([]);
  const [catalogos, setCatalogos] = useState({});
  const [cargando, setCargando] = useState(true);
  const [busqueda, setBusqueda] = useState("");
  const [filtroEstado, setFiltroEstado] = useState(
    Object.keys(ESTADOS).reduce((a, k) => ({ ...a, [k]: true }), {})
  );
  const [filtroResp, setFiltroResp] = useState({});

  const [fechaInicioDesde, setFechaInicioDesde] = useState("");
  const [fechaInicioHasta, setFechaInicioHasta] = useState("");
  
  const [pagina, setPagina] = useState(1);
  const [orden, setOrden] = useState({ col: "fecha_inicio", dir: "desc" });

  const [modalAbierto, setModalAbierto] = useState(false);
  const [modoModal, setModoModal] = useState(null);
  const [dataModal, setDataModal] = useState(null);

  const base = `actividades/${CONFIG.codigoCliente()}`;
  const norm = (s) => s?.toLowerCase().replace(/\s+/g, "_") || "";

  const cargar = async () => {
    setCargando(true);
    try {
      const [modulos, tipos, funcionarios, listado] = await Promise.all([
        consultarSimple(`${base}/modulos`),
        consultarSimple(`${base}/tipos`),
        consultarSimple(`${base}/funcionarios`),
        consultarSimple(`${base}/listado`)
      ]);
      
      setCatalogos({ modulos, tipos, funcionarios });
      setDatos(Object.entries(listado || {}).map(([id, item]) => ({ id, ...item })));
    } catch (e) {
      console.error(e);
    } finally {
      setCargando(false);
    }
  };

  useEffect(() => {
    cargar();
  }, []);

  useEffect(() => {
    setPagina(1);
  }, [busqueda, filtroEstado, filtroResp, fechaInicioDesde, fechaInicioHasta]);

  useEffect(() => {
    const resps = [...new Set(datos.map(d => d.responsable).filter(Boolean))];
    setFiltroResp(resps.reduce((a, r) => ({ ...a, [r]: true }), {}));
  }, [datos]);

  const abrirModal = (modo, data = null) => {
    setModoModal(modo);
    setDataModal(data);
    setModalAbierto(true);
  };

  const cerrarModal = () => {
    setModalAbierto(false);
    setModoModal(null);
    setDataModal(null);
  };

  const guardar = async (formData) => {
    const payload = {
      ...formData,
      tiempo_real: parseFloat(formData.tiempo_real) || 0,
      fecha_modificacion: new Date().toISOString()
    };

    if (modoModal === "editar") {
      await actualizarRegistro(`${base}/listado/${dataModal.id}`, payload);
    } else {
      await crearRegistro(`${base}/listado`, {
        ...payload,
        fecha_creacion: new Date().toISOString()
      });
    }

    cerrarModal();
    await cargar();
  };

  const filtrados = datos.filter(d => {
    const estadosActivos = Object.entries(filtroEstado)
      .filter(([_, v]) => v)
      .map(([k]) => k);
    const respsActivos = Object.entries(filtroResp)
      .filter(([_, v]) => v)
      .map(([k]) => k);

    const coincideBusqueda = !busqueda || 
      Object.values(d).some(v => 
        String(v).toLowerCase().includes(busqueda.toLowerCase())
      );
    const coincideEstado = estadosActivos.length === 0 || 
      estadosActivos.includes(norm(d.estado));
    const coincideResp = respsActivos.length === 0 || 
      respsActivos.includes(d.responsable);

    const fechaInicio = d.fecha_inicio ? new Date(d.fecha_inicio) : null;
    
    const cumpleFechaInicioDesde = !fechaInicioDesde || !fechaInicio || 
      fechaInicio >= new Date(fechaInicioDesde);
    const cumpleFechaInicioHasta = !fechaInicioHasta || !fechaInicio || 
      fechaInicio <= new Date(fechaInicioHasta);

    return coincideBusqueda && coincideEstado && coincideResp &&
           cumpleFechaInicioDesde && cumpleFechaInicioHasta;
  });

  const ordenados = [...filtrados].sort((a, b) => {
    let [va, vb] = [a[orden.col], b[orden.col]];
    
    if (orden.col.includes("fecha")) {
      va = new Date(va || 0).getTime();
      vb = new Date(vb || 0).getTime();
    } else {
      va = String(va || "").toLowerCase();
      vb = String(vb || "").toLowerCase();
    }

    return orden.dir === "asc" ? (va > vb ? 1 : -1) : (va < vb ? 1 : -1);
  });

  const porPag = 500;
  const totalPags = Math.ceil(ordenados.length / porPag);
  const paginados = ordenados.slice((pagina - 1) * porPag, pagina * porPag);

  const totalHoras = filtrados.reduce((total, item) => {
    return total + (parseFloat(item.tiempo_real) || 0);
  }, 0);

  if (cargando) return <AnimacionCarga />;

  return (
    <div>
      <BarraSuperior />
      <div className="BloqueModulo">
        <div className="Filtros">
          <div style={{ marginBottom: "15px" }}>
            <p>Buscar:</p>
            <input
              type="text"
              value={busqueda}
              onChange={e => setBusqueda(e.target.value)}
              placeholder="Buscar en la tabla..."
            />
          </div>

          <div style={{ marginBottom: "15px" }}>
            <b><p style={{ marginBottom: "8px" }}>Filtrar por fecha de inicio:</p></b>
            <div style={{ display: "flex", gap: "20px", alignItems: "center", marginLeft: "10px" }}>
              <label style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                <span style={{ fontSize: "14px" }}>Desde:</span>
                <input
                  type="date"
                  value={fechaInicioDesde}
                  onChange={e => setFechaInicioDesde(e.target.value)}
                  style={{
                    padding: "6px 10px",
                    border: "1px solid #ddd",
                    borderRadius: "4px",
                    fontSize: "14px"
                  }}
                />
              </label>
              <label style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                <span style={{ fontSize: "14px" }}>Hasta:</span>
                <input
                  type="date"
                  value={fechaInicioHasta}
                  onChange={e => setFechaInicioHasta(e.target.value)}
                  style={{
                    padding: "6px 10px",
                    border: "1px solid #ddd",
                    borderRadius: "4px",
                    fontSize: "14px"
                  }}
                />
              </label>
              {(fechaInicioDesde || fechaInicioHasta) && (
                <button
                  onClick={() => {
                    setFechaInicioDesde("");
                    setFechaInicioHasta("");
                  }}
                  style={{
                    padding: "6px 12px",
                    backgroundColor: "#f44336",
                    color: "white",
                    border: "none",
                    borderRadius: "4px",
                    cursor: "pointer",
                    fontSize: "13px"
                  }}
                >
                  Limpiar
                </button>
              )}
            </div>
          </div>

          <div style={{ marginBottom: "15px" }}>
            <b><p style={{ marginBottom: "8px" }}>Filtrar por responsable:</p></b>
            <div style={{ display: "flex", flexWrap: "wrap", gap: "15px" }}>
              {Object.keys(filtroResp).sort().map(resp => (
                <label
                  key={resp}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                    cursor: "pointer",
                    marginLeft: "10px"
                  }}
                >
                  <input
                    type="checkbox"
                    checked={filtroResp[resp]}
                    onChange={e => setFiltroResp({ 
                      ...filtroResp, 
                      [resp]: e.target.checked 
                    })}
                    style={{ cursor: "pointer" }}
                  />
                  <span style={{ fontSize: "14px" }}>{resp}</span>
                </label>
              ))}
            </div>
          </div>

          <div style={{ marginBottom: "15px" }}>
            <b><p style={{ marginBottom: "8px" }}>Filtrar por estado:</p></b>
            <div style={{ display: "flex", flexWrap: "wrap", gap: "15px" }}>
              {Object.entries(ESTADOS).map(([k, v]) => (
                <label
                  key={k}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                    cursor: "pointer",
                    marginLeft: "10px"
                  }}
                >
                  <input
                    type="checkbox"
                    checked={filtroEstado[k]}
                    onChange={e => setFiltroEstado({ 
                      ...filtroEstado, 
                      [k]: e.target.checked 
                    })}
                    style={{ cursor: "pointer" }}
                  />
                  <span style={{ fontSize: "14px" }}>{v.label}</span>
                </label>
              ))}
            </div>
          </div>

          <p style={{ marginTop: "10px" }}>
            Mostrando {filtrados.length} de {datos.length} registros
          </p>

          <p style={{ marginTop: "10px" }}>
            Horas utilizadas: {totalHoras.toFixed(1)}
          </p>
        </div>

        <div className="ListadoInmuebles" style={{ overflowX: "auto" }}>
          {totalPags > 1 && (
            <nav>
              <ul className="paginacion">
                {[...Array(totalPags)].map((_, i) => (
                  <li key={i} className={pagina === i + 1 ? "active" : ""}>
                    <button
                      onClick={() => setPagina(i + 1)}
                      className="page-link"
                    >
                      {i + 1}
                    </button>
                  </li>
                ))}
              </ul>
            </nav>
          )}

          <table className="tabla-responsive" style={{ width: "100%", tableLayout: "auto" }}>
            <thead>
              <tr>
                {COLS.map(c => (
                  <th
                    key={c.k}
                    onClick={() => setOrden({
                      col: c.k,
                      dir: orden.col === c.k && orden.dir === "asc" ? "desc" : "asc"
                    })}
                    style={{ cursor: "pointer" }}
                  >
                    {c.l} {orden.col === c.k && (orden.dir === "asc" ? "▲" : "▼")}
                  </th>
                ))}
                <th style={{ minWidth: "100px" }}>OPCIONES</th>
              </tr>
            </thead>
            <tbody>
              {paginados.length > 0 ? (
                paginados.map(f => (
                  <tr key={f.id}>
                    {COLS.map(c => (
                      <td
                        key={c.k}
                        data-label={c.l}
                        style={{
                          maxWidth: c.k === "comentarios" ? "300px" : "auto",
                          wordWrap: c.k === "comentarios" ? "break-word" : "normal"
                        }}
                      >
                        {c.k === "estado" ? (
                          <Badge val={f.estado} cfg={ESTADOS[norm(f.estado)] || {}} />
                        ) : c.k === "tipo" && catalogos.tipos?.[f.tipo] ? (
                          <Badge val={f.tipo} cfg={catalogos.tipos[f.tipo]} />
                        ) : (
                          f[c.k]
                        )}
                      </td>
                    ))}
                    <td data-label="OPCIONES">
                      <button
                        onClick={() => abrirModal("editar", f)}
                        style={{
                          padding: "6px 12px",
                          backgroundColor: "#f44336",
                          color: "white",
                          border: "none",
                          borderRadius: "4px",
                          cursor: "pointer",
                          fontSize: "13px",
                          whiteSpace: "nowrap"
                        }}
                      >
                        Editar
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="11" style={{ textAlign: "center", padding: 20 }}>
                    {busqueda ||
                    Object.values(filtroResp).some(v => !v) ||
                    Object.values(filtroEstado).some(v => !v) ||
                    fechaInicioDesde || fechaInicioHasta
                      ? "No se encontraron resultados"
                      : "No hay datos disponibles"}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <BotonFlotante
          opciones={[
            { texto: "Refrescar", icono: "🔄", accion: cargar },
            { texto: "Nueva actividad", icono: "➕", accion: () => abrirModal("crear") }
          ]}
          data={datos}
          headers={COLS.map(c => ({ label: c.l, key: c.k }))}
          nombreArchivo="listado_actividades"
        />
      </div>

      <FormularioModal
        isOpen={modalAbierto}
        modo={modoModal}
        dataInicial={dataModal}
        catalogos={catalogos}
        onClose={cerrarModal}
        onSave={guardar}
      />
    </div>
  );
};

const S = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0,0,0,0.6)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000,
    padding: "20px",
    overflowY: "auto"
  },
  modal: {
    backgroundColor: "white",
    borderRadius: "12px",
    width: "100%",
    maxWidth: "1400px",
    maxHeight: "90vh",
    display: "flex",
    flexDirection: "column",
    boxShadow: "0 10px 40px rgba(0,0,0,0.2)"
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "25px 40px",
    borderBottom: "2px solid #f0f0f0"
  },
  titulo: {
    fontSize: "24px",
    fontWeight: "600",
    color: "#333",
    margin: 0
  },
  cerrar: {
    background: "none",
    border: "none",
    fontSize: "28px",
    cursor: "pointer",
    color: "#999",
    width: "40px",
    height: "40px",
    borderRadius: "50%",
    transition: "all 0.2s"
  },
  contenido: {
    padding: "30px 40px",
    overflowY: "auto",
    flex: 1
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    gap: "25px",
    marginBottom: "30px"
  },
  campo: {
    display: "flex",
    flexDirection: "column"
  },
  label: {
    fontSize: "14px",
    fontWeight: "600",
    color: "#555",
    marginBottom: "8px"
  },
  req: {
    color: "#f44336",
    fontSize: "16px"
  },
  input: {
    width: "100%",
    padding: "12px 15px",
    borderRadius: "8px",
    border: "1.5px solid #ddd",
    fontSize: "14px",
    boxSizing: "border-box",
    outline: "none",
    fontFamily: "inherit"
  },
  textarea: {
    width: "100%",
    padding: "12px 15px",
    borderRadius: "8px",
    border: "1.5px solid #ddd",
    fontSize: "14px",
    minHeight: "100px",
    resize: "vertical",
    outline: "none",
    fontFamily: "inherit"
  },
  textareaL: {
    width: "100%",
    padding: "12px 15px",
    borderRadius: "8px",
    border: "1.5px solid #ddd",
    fontSize: "14px",
    minHeight: "150px",
    maxHeight: "250px",
    resize: "vertical",
    outline: "none",
    fontFamily: "inherit"
  },
  botones: {
    marginTop: "30px",
    display: "flex",
    gap: "15px",
    justifyContent: "flex-end",
    paddingTop: "20px",
    borderTop: "2px solid #f0f0f0"
  },
  boton: {
    padding: "12px 28px",
    border: "none",
    borderRadius: "8px",
    fontSize: "15px",
    fontWeight: "600",
    cursor: "pointer",
    boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
  },
  btnPri: {
    backgroundColor: "#4CAF50",
    color: "white"
  },
  btnSec: {
    backgroundColor: "#f44336",
    color: "white"
  }
};

export default ActividadesUnificado;